import { createBrowserRouter } from 'react-router-dom';
import Home from './components/Home.jsx';
import Chapters from './components/Chapters.jsx';
import ProtectedRoute from './components/ProtectedRoute';
import UserLogin from './components/UserLogin';
import QuestionGeneration from './components/QuestionGeneration';

const router = createBrowserRouter([
  { path: '/', element: <UserLogin /> },
  { path: '/login', element: <UserLogin /> },
  { 
    path: '/home', 
    element: <ProtectedRoute><Home /></ProtectedRoute> 
  },
  { 
    path: '/:subject/chapters', 
    element: <ProtectedRoute><Chapters /></ProtectedRoute> 
  },
  {
    path: '/question-generation',
    element: <ProtectedRoute><QuestionGeneration /></ProtectedRoute>  
  }
]);

export default router;